import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChatWidgetComponent } from './chat-widget.component';
import { ChatService } from './chat.service';
import { PartnerService } from 'src/app/views/registration/partners/crud-service';

@NgModule({
  declarations: [
    ChatWidgetComponent, // Componente do chat
  ],
  imports: [
    CommonModule,
    FormsModule, // Necessário para usar ngModel no template
  ],
  providers: [
    ChatService,PartnerService // Serviço do chat
  ],
  exports: [
    ChatWidgetComponent, // Exporta o componente para que ele possa ser usado em outros módulos
  ],
})
export class ChatModule {}
